function cov_2ed2lssngd() {
  var path = "/app/src/utils/replace-string-tag-to-component.tsx";
  var hash = "7ad70c5d04bb0c8f126c138d6b16cbcd011e3d56";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/replace-string-tag-to-component.tsx",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 43
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "2": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 14,
          column: 15
        }
      },
      "3": {
        start: {
          line: 16,
          column: 30
        },
        end: {
          line: 18,
          column: 7
        }
      },
      "4": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 58
        }
      },
      "5": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "6": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "7": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "8": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "9": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 48
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 44
          }
        },
        loc: {
          start: {
            line: 6,
            column: 10
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 10
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 30
          },
          end: {
            line: 16,
            column: 31
          }
        },
        loc: {
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 17,
            column: 58
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 14,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 14,
            column: 9
          }
        }, {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 15
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 21,
            column: 70
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 10
          },
          end: {
            line: 20,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 10
          },
          end: {
            line: 20,
            column: 24
          }
        }, {
          start: {
            line: 20,
            column: 28
          },
          end: {
            line: 20,
            column: 54
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 24,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 24,
            column: 61
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 23,
            column: 24
          }
        }, {
          start: {
            line: 23,
            column: 28
          },
          end: {
            line: 23,
            column: 54
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7ad70c5d04bb0c8f126c138d6b16cbcd011e3d56"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ed2lssngd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ed2lssngd();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
cov_2ed2lssngd().s[0]++;
export var replaceStringTagToComponent = function replaceStringTagToComponent(string, wrapperMap) {
  cov_2ed2lssngd().f[0]++;
  cov_2ed2lssngd().s[1]++;
  // Returning 'any' because it's hard to determine type due to various possible values.
  return string.split(/(<[a-z]+>[^<]+<\/[a-z]+>|<[a-z]+\s?\/>)/).map(function (splittedTextValue, i) {
    cov_2ed2lssngd().f[1]++;
    var _ref = (cov_2ed2lssngd().s[2]++, (cov_2ed2lssngd().b[0][0]++, splittedTextValue.match(/<([a-z]+)>([^<]+)<\/[a-z]+>|<([a-z]+)\s?\/>/)) || (cov_2ed2lssngd().b[0][1]++, [])),
      _ref2 = _slicedToArray(_ref, 4),
      tagWithContent = _ref2[1],
      innerText = _ref2[2],
      selfClosingTag = _ref2[3];
    cov_2ed2lssngd().s[3]++;
    var renderComponent = function renderComponent(content) {
      cov_2ed2lssngd().f[2]++;
      cov_2ed2lssngd().s[4]++;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: i
      }, content);
    };
    cov_2ed2lssngd().s[5]++;
    if ((cov_2ed2lssngd().b[2][0]++, tagWithContent) && (cov_2ed2lssngd().b[2][1]++, wrapperMap[tagWithContent])) {
      cov_2ed2lssngd().b[1][0]++;
      cov_2ed2lssngd().s[6]++;
      return renderComponent(wrapperMap[tagWithContent](innerText));
    } else {
      cov_2ed2lssngd().b[1][1]++;
    }
    cov_2ed2lssngd().s[7]++;
    if ((cov_2ed2lssngd().b[4][0]++, selfClosingTag) && (cov_2ed2lssngd().b[4][1]++, wrapperMap[selfClosingTag])) {
      cov_2ed2lssngd().b[3][0]++;
      cov_2ed2lssngd().s[8]++;
      return renderComponent(wrapperMap[selfClosingTag]());
    } else {
      cov_2ed2lssngd().b[3][1]++;
    }
    cov_2ed2lssngd().s[9]++;
    return renderComponent(splittedTextValue);
  });
};